export const ADD_TIME_OFF_REQUEST = 'ADD_TIME_OFF_REQUEST';
export const EDIT_TIME_OFF_REQUEST = 'EDIT_TIME_OFF_REQUEST';
export const REVIEW_TIME_OFF_REQUEST = 'REVIEW_TIME_OFF_REQUEST';
export const DELETE_TIME_OFF_REQUEST = 'DELETE_TIME_OFF_REQUEST';
export const GET_TIME_OFF_SUMMARY_REQUEST = 'GET_TIME_OFF_SUMMARY_REQUEST';
export const GET_CURRENT_LEAVE_REQUEST = 'GET_CURRENT_LEAVE_REQUEST';
export const GET_PENDING_TIME_OFF_REQUEST = 'GET_PENDING_TIME_OFF_REQUEST';
export const GET_CURRENTLY_OUT_REQUEST = 'GET_CURRENTLY_OUT_REQUEST';
export const GET_TIME_OFF_OVERLAPS_REQUEST = 'GET_TIME_OFF_OVERLAPS_REQUEST';

export const addTimeOff = (userId, startDate, endDate, days, type, description, callback) => ({
    type: ADD_TIME_OFF_REQUEST,
    payload: { userId, startDate, endDate, days, type, description, callback }
});

export const editTimeOff = (id, startDate, endDate, days, type, description, callback) => ({
    type: EDIT_TIME_OFF_REQUEST,
    payload: { id, startDate, endDate, days, type, description, callback }
});

export const getTimeOffSummary = (userId, callback) => ({
    type: GET_TIME_OFF_SUMMARY_REQUEST,
    payload: { userId, callback }
});

export const getCurrentLeave = (userId, callback) => ({
    type: GET_CURRENT_LEAVE_REQUEST,
    payload: { userId, callback }
});

export const getPendingTimeOff = (callback) => ({
    type: GET_PENDING_TIME_OFF_REQUEST,
    payload: { callback }
});

export const getCurrentlyOut = (callback) => ({
    type: GET_CURRENTLY_OUT_REQUEST,
    payload: { callback }
});

export const getTimeOffOverlaps = (userId, startDate, endDate, excludeId, callback) => ({
    type: GET_TIME_OFF_OVERLAPS_REQUEST,
    payload: { userId, startDate, endDate, excludeId, callback }
});

export const reviewTimeOff = (id, status, callback) => ({
    type: REVIEW_TIME_OFF_REQUEST,
    payload: { id, status, callback }
});

export const deleteTimeOff = (id, callback) => ({
    type: DELETE_TIME_OFF_REQUEST,
    payload: { id, callback }
});
